import React from 'react'

export default function Header() {
    return (

        <div className="row">
            <div className="col-sm-12">
                <div className="card">
                    <div className="text-center">
                    </div>
                    <div className="card-body">
                        <h4 className="card-title text-center">
                            CyberLearn -
                            Virtual Dressing Room
                        </h4>
                    </div>
                </div>
                <hr />
            </div>
        </div>

    )
}
